export default {
    namespaced: true,
    state: {
        access_industry_page_ids: {},
        access_page_group_page_ids: {},
        company_visit_list_page_ids: {},
        person_visit_list_page_ids: {}
    },
    mutations: {
        // access_industry用のページIDをセット
        setAccessIndustryPageIds(state, access_industry_page_ids) {
            state.access_industry_page_ids = access_industry_page_ids;
        },
        // access_page_group用のページIDをセット
        setAccessPageGroupPageIds(state, access_page_group_page_ids) {
            state.access_page_group_page_ids = access_page_group_page_ids;
        },
        // company_visit_list用のページIDをセット
        setCompanyVisitListPageIds(state, company_visit_list_page_ids) {
            state.company_visit_list_page_ids = company_visit_list_page_ids;
        },
        // person_visit_list用のページIDをセット
        setPersonVisitListPageIds(state, person_visit_list_page_ids) {
            state.person_visit_list_page_ids = person_visit_list_page_ids;
        }
    },
    actions: {},
    getters: {
        // access_industry用のページIDを取得
        getAccessIndustryPageIds(state) {
            return state.access_industry_page_ids;
        },
        // access_page_group用のページIDを取得
        getAccessPageGroupPageIds(state) {
            return state.access_page_group_page_ids;
        },
        // company_visit_list用のページIDを取得
        getCompanyVisitListPageIds(state) {
            return state.company_visit_list_page_ids;
        },
        // person_visit_list用のページIDを取得
        getPersonVisitListPageIds(state) {
            return state.person_visit_list_page_ids;
        }
    }
};
